import React, { Component, Fragment } from 'react';
import DataTables from 'organisms/DataTable';
import { ConformityReportModal, ConformityReportView } from 'organisms/NewTaskModal';
import ModalPage from 'templates/ModalPage';
import { CONFORMITY_REPORT, CONFORMITY_DEPTS, CONFORMITY_TYPE } from 'fixtures/api';
import { NewConformityReport } from 'fixtures/TemplateData';
import { taskUnconformityCreate } from 'fixtures/permissions';
import { permissionCheck } from 'helpers/permissionCheckHelper';
import { submitTask } from 'services/taskService';
import { getTaskListData } from 'Redux/actions/TaskActions';
import { getAllConformityCategoriesData } from 'Redux/actions/ConformityCategoryListActions'
import { getCCsData } from 'Redux/actions/CCListActions';
import { getContractorPitLookupData, getLookupByType, setPitPlanData } from 'Redux/actions/LookupActions';
import { toggleIsShowTab, toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { getDeptsDataByCompany } from 'Redux/actions/DepartmentListActions'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { conformityConfig } from './tableConfig';
import { TableWrapper, BtnAddNew, RoundedWrapper, FilterRow, FilterCol } from './styles';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';
import moment from 'moment';
import lo from 'lodash';
import { Label } from 'components/atoms/Texts/TxtLabel';
import FormTypeahead from 'components/atoms/Inputs/FormTypeahead';
import FormSelect from 'components/atoms/Inputs/FormSelect';
import { Months, Years, Status } from 'fixtures/timeValues'
import ButtonReg from 'components/atoms/Buttons/Button';
import IconPng from 'components/atoms/IconPng/index';

const ic_eye = require('App/assets/images/ic_eye.png')
const defaultFilter = {
  month: new Date().getMonth() + 1,
  year: new Date().getFullYear(),
  status: '',
  locationType: null,
  category: null,
}

class ConformityReportList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isShowModalNew: false,
      isShowModalView: false,
      isSubmitDisabled: true,
      isSubmitted: false,
      lookups: {
        contractors: [],
        pits: [],
        seams: [],
        types: [],
        depts: [],
        categories: [],
      },
      filter: defaultFilter,
      isShowFilter: false,
      NewTaskData: {},
      ViewTaskData: null,
      allowCreate: false
    }
  }

  // LIFECYCLES
  componentDidMount() {
    this.props.toggleIsShowTab(true)
    this.props.toggleIsLoading(true)
    this.props.getContractorPitLookupData()
    this.props.getLookupByType(CONFORMITY_TYPE)
    this.props.getLookupByType(CONFORMITY_DEPTS)
    this.props.getDeptsDataByCompany()
    this.props.getTaskListData(CONFORMITY_REPORT, this.state.filter)
    this.props.getAllConformityCategoriesData()
    this.checkPermission()
  }

  componentDidUpdate(prevProps) {
    const { conformityReports, contractorPitLookups, conformityLookups, deptsList, effectivePitPlan, viewState: { isLoading }, userLogin, globals } = this.props
    const { lookups, NewTaskData } = this.state
    if (prevProps.conformityReports !== conformityReports && isLoading) {
      if (contractorPitLookups) {
        const obj = Object.assign(lookups)
        lookups.contractors = contractorPitLookups
        this.setState({ lookups: obj })
      }
      if (deptsList) {
        const obj = Object.assign(lookups)
        lookups.depts = deptsList
        this.setState({ lookups: obj })
      }

      if (conformityLookups) {
        const obj = Object.assign(lookups)
        const { types } = conformityLookups
        lookups.types = types
        this.setState({ lookups: obj })
      }
      this.props.toggleIsLoading(false)
    }
    if (prevProps.effectivePitPlan !== effectivePitPlan && isLoading) {
      const obj = Object.assign(lookups)
      const task = Object.assign(NewTaskData)

      lookups.seams = effectivePitPlan.seams

      this.setState({ lookups: obj, NewTaskData: task }, () => {
        this.props.toggleIsLoading(false)
      })
    }
    if (prevProps.userLogin !== userLogin) {
      this.checkPermission()
    }
    if (prevProps.globals.company !== globals.company) {
      this.onFilterSubmit()
    }
  }

  // METHODS
  // method for checking access permission
  checkPermission() {
    const { userLogin } = this.props
    if (userLogin && userLogin.userDetail) {
      const { userDetail: { permissions } } = userLogin
      this.setState({
        allowCreate: permissionCheck(permissions, taskUnconformityCreate),
      })
    }
  }

  // change filter state
  onChangeFilter(val, field) {
    let f = { ...this.state.filter }
    f[field] = val
    this.setState({ filter: f })
  }

  onFilterSubmit() {
    const { category, ...f } = this.state.filter
    f.locationType = f.locationType ? f.locationType.name : null
    f.conformityCategoryId = category ? category.conformityCategoryId : null
    f.companyId = this.props.globals.company ? this.props.globals.company.companyId : null
    this.props.toggleIsLoading(true)
    this.props.getTaskListData(CONFORMITY_REPORT, f)
  }

  onResetFilter() {
    this.props.toggleIsLoading(true)
    this.setState({ filter: defaultFilter }, () => {
      this.props.getTaskListData(CONFORMITY_REPORT, this.state.filter)
    })
  }

  // handle search cc
  onSearchCC(keyword = '') {
    const { pitId } = this.state.NewTaskData
    const { getCCsData } = this.props
    if (!!pitId && pitId !== '-') {
      getCCsData(keyword, pitId)
    }
  }

  // change task data state
  onChangeNewTaskData(val, field) {
    const { lookups } = this.state
    let task = { ...this.state.NewTaskData }

    if (field === 'photosBase64') {
      const files = []
      const thumbs = []

      for (var i = 0; i < val.length; i++) {
        const file = val[i]
        let reader = new FileReader()
        reader.addEventListener("load", (event) => {
          thumbs.push(event.target.result) // non-trimmed base64 for preview
          files.push(event.target.result.split(',')[1]) // trimmed base64 for posting
          task[field] = files
          task.photo = thumbs
          this.setState({ NewTaskData: task })
        })
        reader.readAsDataURL(file)
      }
    } else {
      task[field] = val
    }

    if (field === 'hideSeamAndSection') {
      if (val) {
        task.seam = NewConformityReport.seam
        task.sectionFrom = NewConformityReport.sectionFrom
        task.sectionTo = NewConformityReport.sectionTo
        task.sectionPrefix = NewConformityReport.sectionPrefix
      } else {
        const { effectivePitPlan } = this.props
        task.seam = effectivePitPlan.seams[0] ? effectivePitPlan.seams[0] : '-'
        task.sectionFrom = effectivePitPlan.sectionFrom
        task.sectionTo = effectivePitPlan.sectionTo
        task.sectionPrefix = effectivePitPlan.sectionPrefix
      }
    }

    if (field === 'conformityCategoryId' && !!val) {
      if (lookups.categories.find(category => category.conformityCategoryId === Number(val)).isUnconformity) {
        task.anyFurtherAction = true
      } else {
        task.anyFurtherAction = false
      }
    }

    const tasksValue = Object.entries(task)
    let emptyField = 0;
    const notRequired = ['cc', 'photo', 'photosBase64']
    const seamAndSectionNotRequired = ['seam', 'sectionFrom', 'sectionTo', 'sectionPrefix']
    for (const [key, value] of tasksValue) {
      if (!notRequired.includes(key) &&
        (task.hideSeamAndSection && !seamAndSectionNotRequired.includes(key)) && 
        (task.conformityCategoryId !== '1' && key !== 'furtherActionDescription')) {
        if (value === null || (value !== null && value.length === 0) || (value !== null && value === '-')) {
          emptyField++
          break
        }
      }
    }
    if (emptyField === 0) {
      this.setState({ isSubmitDisabled: false })
    }

    this.setState({ NewTaskData: task }, () => {
      if (field === 'contractorId') {
        const {
          NewTaskData: { contractorId },
          lookups: { contractors },
          lookups
        } = this.state
        const found = contractors.find(el => el.id === parseInt(contractorId))
        const lookupObj = Object.assign(lookups)
        lookups.pits = found.pits
        this.setState({ lookups: lookupObj })
      }
      if (field === 'pitId') {
        const { conformityCategoriesList, userLogin } = this.props
        const { NewTaskData: { pitId }, lookups } = this.state
        const pit = lookups.pits.find(pit => pit.id === Number(val))
        this.props.setPitPlanData(pitId)
        this.props.toggleIsLoading(true)
        this.props.getCCsData('', pitId)
        this.props.getDeptsDataByCompany([pit.companyId])
        const lookupObj = Object.assign(lookups)
        lookups.categories = conformityCategoriesList
          .filter(category => category.companyId === pit.companyId)
          .map(category => ({
            ...category,
            conformityCategoryId: category.conformityCategory.id,
            conformityCategoryName: category.conformityCategory.name,
          }))
        if (userLogin.userDetail.userRole === 'CONTRACTOR') {
          lookups.categories = lookups.categories.filter(category => category.isContractorVisible)
        }
        this.setState({ lookups: lookupObj })
      }
    })
  }

  onSubmitUser() {
    this.setState({ isSubmitted: true, isSubmitDisabled: true }, () => { this.submitNewTask() })
  }

  submitNewTask() {
    const { userLogin: { userDetail } } = this.props

    const transformed = lo.cloneDeep(this.state.NewTaskData) // deep clone to avoid mutation
    transformed.timeOccurence = moment(transformed.timeOccurence).format('HH:mm')
    transformed.locationType = transformed.locationType.name
    transformed.cc = transformed.cc.map(d => d.id)

    const { photo, contractorId, ...rest } = transformed // trimmed unused keys
    this.setState({ isSubmitDisabled: true }, async () => {
      try {
        await submitTask(CONFORMITY_REPORT, { ...rest }, userDetail)
        this.setState({ isSubmitted: false }, () => {
          this.addNewTask()
        })
      } catch (error) {
        this.setState({ isSubmitted: false })
      }
    })
  }

  addNewTask() {
    this.switchModal(lo.cloneDeep(NewConformityReport), 'New')  // deep clone from template data and opens the modal
  }

  switchModal(taskData, type) {
    if (type === 'New') this.setState({ isSubmitDisabled: true })
    if (type === 'View') this.props.getDeptsDataByCompany()
    this.setState({ [`${type}TaskData`]: taskData }, () => {
      this.setState({ [`isShowModal${type}`]: !this.state[`isShowModal${type}`] })
    })
  }

  onSizePerPageChange = (size) => {
    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.sizePerPage['Conformity'] = size
    setLocalSettingsTableData(settings)
  }

  renderLeftSection() {
    return (
      <Fragment>
        {this.state.allowCreate &&
          <BtnAddNew
            btnTxt={'Add'}
            disabled={false}
            onClick={() => this.addNewTask()}
            width={'78px'}
          />
        }
      </Fragment>
    )
  }

  renderFilterRow() {
    const inputConfig = {
      border: this.props.theme.mocaGrey,
      rad: '6px',
      width: 'auto',
      yxPadding: '9px 12px',
      height: '34px',
    }

    const { conformityCategoriesList } = this.props
    const { lookups, filter } = this.state

    const categories = conformityCategoriesList.map((c) => ({
      ...c,
      conformityCategoryName: c.conformityCategory.name,
    }))

    return (
      <FilterRow>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Month
          </Label>
          <FormSelect
            placeholder={`month`}
            onChangeVal={e => this.onChangeFilter(e.target.value, 'month')}
            options={Months}
            value={filter.month}
            valField={'value'}
            dispField={'label'}
            arrowSize={'8%'}
            mr={window.innerWidth <= 960 ? '.5rem' : '1.5rem'}
            {...inputConfig}
          />
        </FilterCol>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Year
          </Label>
          <FormSelect
            placeholder={`year`}
            onChangeVal={e => this.onChangeFilter(e.target.value, 'year')}
            options={Years}
            value={filter.year}
            valField={'year'}
            dispField={'year'}
            arrowSize={'8%'}
            mr={window.innerWidth <= 960 ? '.5rem' : '1.5rem'}
            {...inputConfig}
          />
        </FilterCol>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Status
          </Label>
          <FormSelect
            placeholder={`status`}
            onChangeVal={e => this.onChangeFilter(e.target.value, 'status')}
            options={Status}
            value={filter.status}
            valField={'value'}
            dispField={'label'}
            arrowSize={'8%'}
            {...inputConfig}
          />
        </FilterCol>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Type
          </Label>
          <FormTypeahead
            placeholder={'type'}
            options={lookups.types || []}
            dispField={'nameDisplay'}
            control={filter.locationType ? [filter.locationType] : []}
            onChangeVal={e => this.onChangeFilter(e, 'locationType')}
            {...inputConfig}
          />
        </FilterCol>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Category
          </Label>
          <FormTypeahead
            placeholder={'category'}
            options={categories || []}
            dispField={'conformityCategoryName'}
            control={filter.category ? [filter.category] : []}
            onChangeVal={e => this.onChangeFilter(e, 'category')}
            {...inputConfig}
          />
        </FilterCol>

        <ButtonReg
          btnTxt={
            <IconPng srcIcon={ic_eye} ml={'0'} mb={'3px'} size={'auto'} h={'13'} showPointer={true} />
          }
          rad={'6px'}
          disabled={false}
          onClick={this.onFilterSubmit.bind(this)}
          width={'34px'}
          height={'34px'}
          margin={'0 9px 0 0'}
        />
        <ButtonReg
          btnTxt="Reset"
          rad={'6px'}
          disabled={false}
          onClick={this.onResetFilter.bind(this)}
          height={'34px'}
          width={'50px'}
        />
      </FilterRow>
    )
  }

  // RENDER
  render() {
    const { conformityReports, settingsTable, viewState: { isLoading, isMobileView } } = this.props
    const { match: { path }, history: { push }, theme } = this.props

    const sizePerPage = settingsTable.sizePerPage['Conformity']
    return (
      <Fragment>
        {!isLoading &&
          <>
            <RoundedWrapper>
              {this.renderFilterRow()}
            </RoundedWrapper>
            <TableWrapper>
              {/* ---------- NEW TASK MODAL ---------- */}
              <ModalPage
                isOpen={this.state.isShowModalNew}
                contentChild={
                  <ConformityReportModal
                    fnChange={this.onChangeNewTaskData.bind(this)}
                    fnSubmit={this.onSubmitUser.bind(this)}
                    fnSwitch={this.switchModal.bind(this, {}, 'New')}
                    newTaskData={this.state.NewTaskData}
                    lookups={this.state.lookups}
                    handleSearchCC={this.onSearchCC.bind(this)}
                    isDisabled={this.state.isSubmitDisabled}
                    isSubmitted={this.state.isSubmitted}
                    {...this.props}
                  />
                }
              />
              {/* ---------- VIEW TASK MODAL ---------- */}
              <ModalPage
                isOpen={this.state.isShowModalView}
                fnSwitch={this.switchModal.bind(this, null, 'View')}
                contentChild={
                  <ConformityReportView
                    fnSwitch={this.switchModal.bind(this, null, 'View')}
                    taskData={this.state.ViewTaskData}
                    lookups={this.state.lookups}
                    {...this.props}
                  />
                }
              />
              {/* ---------- DATA TABLE ---------- */}
              <DataTables
                minWidth={'700px'}
                leftSlot={this.renderLeftSection()}
                dataList={conformityReports}
                columnConfig={conformityConfig(path, push, theme, this.switchModal.bind(this), isMobileView)}
                sizePerPage={sizePerPage}
                onSizePerPageChange={this.onSizePerPageChange}
              />
              <input id='pickPhoto' hidden type="file" accept="image/*" onChange={e => this.onChangeNewTaskData(e.target.files, 'photosBase64')} multiple />
            </TableWrapper>
          </>
        }
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    contractorPitLookups: state.contractorPitLookups,
    effectivePitPlan: state.effectivePitPlan,
    conformityReports: state.conformityReports,
    conformityLookups: state.conformityReportLookup,
    ccsList: state.ccsList,
    viewState: state.viewState,
    userLogin: state.userLogin,
    conformityCategoriesList: state.conformityCategoriesList,
    deptsList: state.deptsList,
    settingsTable: state.settingsTable,
    globals: state.globals,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsShowTab,
      toggleIsLoading,
      getTaskListData,
      getAllConformityCategoriesData,
      getCCsData,
      getContractorPitLookupData,
      setPitPlanData,
      getLookupByType,
      getDeptsDataByCompany,
      setLocalSettingsTableData,
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ConformityReportList)
  )
)
